module.exports = __webpack_public_path__ + "img/service-professional-services-2.981e0112.jpg";